import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import moment from 'moment';
import ReviewWorkspaceTopLevelComment from './ReviewWorkspaceTopLevelComment';
import ReviewWorkspaceCommentReplies from './ReviewWorkspaceCommentReplies';

export default class ReviewWorkspaceCommentDisplay extends Component {
    static propTypes = {
        handleAssetReviewItemSubmit: PropTypes.func,
        handleAssetReviewItemEdit: PropTypes.func,
        onResolve: PropTypes.func,
        onDelete: PropTypes.func,
        assetReviewItem: PropTypes.object,
        loggedInUserId: PropTypes.string,
        isBuilder: PropTypes.bool,
        isContentAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            isEditing: false,
            showReplies: false
        };
    }

    handleReplyIconClick = () => {
        const { showReplies } = this.state;
        if (!showReplies) {
            return this.setState({ showReplies: true });
        }
        return null;
    };

    renderCommentAuthor = (assetReviewItem) => (
        <p className={'comment-author-name'}>
            {assetReviewItem.userProfileId === this.props.loggedInUserId
                ? 'You'
                : `${assetReviewItem.userFirstName || ''} ${
                      (assetReviewItem.userLastName && assetReviewItem.userLastName[0]) || ''
                  }`}
        </p>
    );

    renderCommentBody = (commentBody, createdOn) => (
        <div>
            <p className={'comment-body'}>{commentBody}</p>
            <h6 className={'comment-item-review-date'}>{moment(createdOn).format('MMM D, YYYY')}</h6>
        </div>
    );

    toggleShowReplies = () => this.setState((prevState) => ({ showReplies: !prevState.showReplies }));

    handleEditIconClick = () => {
        this.setState({ isEditing: true });
    };

    render() {
        const { isEditing, showReplies } = this.state;
        const {
            assetReviewItem = {},
            assetReviewItem: { replyItems = [] } = {},
            isBuilder,
            loggedInUserId,
            handleAssetReviewItemSubmit,
            handleAssetReviewItemEdit,
            onResolve,
            onDelete,
            isContentAdmin
        } = this.props;

        return (
            <div className={cns('comment-item', { editing: isEditing })} key={assetReviewItem._id}>
                <ReviewWorkspaceTopLevelComment
                    assetReviewItem={assetReviewItem}
                    isBuilder={isBuilder}
                    handleAssetReviewItemEdit={handleAssetReviewItemEdit}
                    loggedInUserId={loggedInUserId}
                    handleReplyIconClick={this.handleReplyIconClick}
                    handleEditIconClick={this.handleEditIconClick}
                    renderCommentAuthor={this.renderCommentAuthor}
                    renderCommentBody={this.renderCommentBody}
                    isEditing={isEditing}
                    onResolve={onResolve}
                    onDelete={onDelete}
                    onSaveEdit={() => this.setState({ isEditing: false })}
                    isContentAdmin={isContentAdmin}
                />
                {(replyItems && replyItems.length) || showReplies ? (
                    <ReviewWorkspaceCommentReplies
                        renderCommentAuthor={this.renderCommentAuthor}
                        renderCommentBody={this.renderCommentBody}
                        replyItems={replyItems}
                        assetReviewItem={assetReviewItem}
                        handleAssetReviewItemSubmit={handleAssetReviewItemSubmit}
                        showReplies={showReplies}
                        toggleShowReplies={this.toggleShowReplies}
                    />
                ) : null}
            </div>
        );
    }
}
